import { Parameter } from "src/graphql";

export function rangeUnitToString(ranged: Omit<Parameter, "__typename">, t: (key: string) => string): string {

    const { val, max, unit } = ranged;

    const uu = unit ? t(unit) : "";
    return `${val || ""}${max ? ` - ${max}` : ""}${(val && unit) ? ` ${uu}` : uu}`.trim()
}

export function singleUnitToString(single: Omit<Parameter, "__typename">, t: (key: string) => string): string {
    const { val, unit } = single;

    const uu = unit ? ` ${t(unit)}` : "";
    return `${val}${uu}`.trim()
}